import React from 'react'
import { Typography } from "@material-ui/core";
import classes from './PopularDestinationCard.module.css'

export default function PopularDestinationCard(props) {
    const {
        handleOnClick,
        item
    } = props

    return (
        <figure className={classes['popular-destination-card']} onClick={handleOnClick}>
            <img
                src={`https://images.skypicker.com/?image=https%3A%2F%2Fimages.kiwi.com%2Fphotos%2F385x320%2F${item.destination.legacyId}.jpg`}
                alt={item.destination.name}
            />
            <div className={classes['popular-destination-details']}>
                <p className={classes['popular-destination__title']}>{item.origin && item.origin.name} to {item.destination && item.destination.name}</p>
                <p className={classes['more-details']}>Get Details</p>
            </div>
        </figure>
    )
}